import { render, staticRenderFns } from "./PaymentSection.vue?vue&type=template&id=395245ce&scoped=true&"
import script from "./PaymentSection.vue?vue&type=script&lang=js&"
export * from "./PaymentSection.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSection.vue?vue&type=style&index=0&id=395245ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395245ce",
  null
  
)

export default component.exports